// bankAccountService.tsx
import { BaseService } from '../../core/BaseService';
import { ChangeStatusRequest, PaginationParams } from '../../type';
import {
  AccountSummaryFilters,
  AccountTransfer,
  BankAccountRequest,
  BankAccountResponse,
  ChangeStatusBankAccountResponse,
  DeleteBankAccountResponse,
  GetAccountLedgerByIdResponse,
  GetAccountTransferByIdResponse,
  GetAccountTransferResponse,
  GetBankAccountBalanceResponse,
  GetBankAccountByIdResponse,
  GetBankAccountsDropdownResponse,
  GetBankAccountsResponse,
  GetFinancesResponse,
} from './interface';

export class BankAccountProfile extends BaseService {
  async createBankAccount(req: BankAccountRequest) {
    return this.post<BankAccountResponse, BankAccountRequest>(`${this.apiUrl}/api/bankaccounts`, req);
  }

  async getBankAccounts(params: PaginationParams) {
    return this.get<GetBankAccountsResponse>(`${this.apiUrl}/api/bankaccounts/paged`, params);
  }

  async getBankAccountsDropdown(params: PaginationParams) {
    return this.get<GetBankAccountsDropdownResponse>(`${this.apiUrl}/api/bankaccounts/get`, params);
  }

  async updateBankAccount(id: number, req: BankAccountRequest) {
    return this.put<BankAccountResponse, BankAccountRequest>(`${this.apiUrl}/api/bankaccounts/${id}`, req);
  }

  async deleteBankAccount(id: number) {
    return this.delete<DeleteBankAccountResponse>(`${this.apiUrl}/api/bankaccounts/${id}`);
  }

  async changeStatusBankAccount(id: number, active: string, req: ChangeStatusRequest) {
    return this.put<ChangeStatusBankAccountResponse, ChangeStatusRequest>(
      `${this.apiUrl}/api/bankaccounts/${active}/${id}`,
      req
    );
  }

  async getBankAccountByID(id: number) {
    return this.get<GetBankAccountByIdResponse>(`${this.apiUrl}/api/bankaccounts/${id}`);
  }

  async getFinanceExpenses(params?: AccountSummaryFilters) {
    return this.get<GetFinancesResponse>(`${this.apiUrl}/api/finance/expense`, params);
  }

  async getFinanceAssets(params?: AccountSummaryFilters) {
    return this.get<GetFinancesResponse>(`${this.apiUrl}/api/finance/assets`, params);
  }

  async getFinanceLiabilities(params?: AccountSummaryFilters) {
    return this.get<GetFinancesResponse>(`${this.apiUrl}/api/finance/liabilities`, params);
  }

  async getFinanceEquities(params?: AccountSummaryFilters) {
    return this.get<GetFinancesResponse>(`${this.apiUrl}/api/finance/equity`, params);
  }

  async getFinanceRevenue(params?: AccountSummaryFilters) {
    return this.get<GetFinancesResponse>(`${this.apiUrl}/api/finance/revenue`, params);
  }

  async getFinanceProfitLoss(params?: AccountSummaryFilters) {
    return this.get<GetFinancesResponse>(`${this.apiUrl}/api/finance/profitloss`, params);
  }

  async getAccountLedgerByID(id: number, params: PaginationParams) {
    return this.get<GetAccountLedgerByIdResponse>(`${this.apiUrl}/api/bankaccounts/ledger/${id}`, params);
  }

  async getAccountTransfers(params: PaginationParams) {
    return this.get<GetAccountTransferResponse>(`${this.apiUrl}/api/bankaccounts/amount/paged`, params);
  }

  async createAccountTransfer(req: AccountTransfer) {
    return this.post<GetAccountTransferByIdResponse, AccountTransfer>(
      `${this.apiUrl}/api/bankaccounts/amount/transfer`,
      req
    );
  }

  async getAccountBalance(id: number) {
    return this.get<GetBankAccountBalanceResponse>(`${this.apiUrl}/api/bankaccounts/balance/${id}`);
  }
}
